import { createRoot } from "react-dom/client";
import RootContainer from "./RootContainer";

// Note our version
console.info("Shopfront Version Details:", __VERSION__);

// Render our application
const rootElement = document.getElementById("root");

if(!rootElement) {
    throw new Error("Root element not found");
}

createRoot(rootElement).render(RootContainer);

declare let module: { hot: any; };

if(module && module.hot) {
    module.hot.accept("./RootContainer.tsx", () => {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const NextRootContainer = require("./RootContainer.tsx").default;

        createRoot(rootElement).render(<NextRootContainer />);
    });
}
